import { render, staticRenderFns } from "./tradelist.vue?vue&type=template&id=a6f768fa&scoped=true&"
import script from "./tradelist.vue?vue&type=script&lang=js&"
export * from "./tradelist.vue?vue&type=script&lang=js&"
import style0 from "./tradelist.vue?vue&type=style&index=0&id=a6f768fa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f768fa",
  null
  
)

export default component.exports